module.exports = __webpack_public_path__ + "static/media/card3_10.a131ad2c.png";